'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13(evaluator$15) {
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13__f_evaluator$5 = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13__f_evaluator$5 = evaluator$15;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 as $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 };
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 as $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 };
$h_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype = $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13__f_evaluator$5.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13, "app.api.CreateGeneralPracticeRequest$PracticeData$$anon$13", ({
  Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 as $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData$$anon$13 };
//# sourceMappingURL=app.api.-Create-General-Practice-Request$-Practice-Data$$anon$13.js.map
